/**
 * verticalCardInfoContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled vertical card info container.
 */
const VerticalCardInfoContainer = styled.div`
  position: relative;
  bottom: ${350 * Screen.widthRatio}px;
  height: ${331.33 * Screen.widthRatio}px;
  width: ${235 * Screen.widthRatio}px;
`;

export default withOpacity(VerticalCardInfoContainer);
